import React from 'react';
import PropTypes from 'prop-types';
import { TeamOutlined, ToolOutlined } from '@ant-design/icons';

import RedistributeSidebarRowItem from './RedistributeSidebarRowItem';

export default function RedistributeSidebar({
  projectLabel,
  userRows,
  equipmentRows,
  columnRowId,
  activeRowId,
  onRowSelect,
}) {
  return (
    <div className="ttg-redistribute-sidebar">
      <div className="ttg-redistribute-sidebar-scroll">
        <div className="ttg-redistribute-sidebar-header">
          <div className="ttg-redistribute-sidebar-header-group">
            <TeamOutlined className="ttg-redistribute-sidebar-group-icon" />
            <span className="ttg-redistribute-sidebar-header-group-label">Team & Equipment</span>
          </div>
          <span className="ttg-redistribute-sidebar-header-project-name">{projectLabel}</span>
        </div>

        {userRows.length > 0 && (
          <div className="ttg-redistribute-sidebar-sub-group">
            <TeamOutlined className="ttg-redistribute-sidebar-sub-group-icon" />
            <span className="ttg-redistribute-sidebar-sub-group-label">Users</span>
          </div>
        )}
        {userRows.map((row) => (
          <RedistributeSidebarRowItem
            key={row.id}
            row={row}
            columnRowId={columnRowId}
            isActive={row.id === activeRowId}
            onPress={() => onRowSelect(row.id)}
          />
        ))}

        {equipmentRows.length > 0 && (
          <div className="ttg-redistribute-sidebar-sub-group">
            <ToolOutlined className="ttg-redistribute-sidebar-sub-group-icon" />
            <span className="ttg-redistribute-sidebar-sub-group-label">Equipment</span>
          </div>
        )}
        {equipmentRows.map((row) => (
          <RedistributeSidebarRowItem
            key={row.id}
            row={row}
            columnRowId={columnRowId}
            isActive={row.id === activeRowId}
            onPress={() => onRowSelect(row.id)}
          />
        ))}
      </div>
    </div>
  );
}

RedistributeSidebar.propTypes = {
  projectLabel: PropTypes.string.isRequired,
  userRows: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  })).isRequired,
  equipmentRows: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  })).isRequired,
  columnRowId: PropTypes.string.isRequired,
  activeRowId: PropTypes.string,
  onRowSelect: PropTypes.func.isRequired,
};
